import { render, staticRenderFns } from "./form-multi-column.vue?vue&type=template&id=007b7ac8&scoped=true&"
import script from "./form-multi-column.vue?vue&type=script&lang=js&"
export * from "./form-multi-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b7ac8",
  null
  
)

export default component.exports